<template>
  <div class="competences">
    <transition name="slide" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'competences-view'
}
</script>

<style lang="scss" scoped>

</style>
